import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { environment } from '@kr/environment';
import { WalletCard } from '@kr/models';
import { OrganizationService } from '@kr/services';

import { WalletDetailsApi } from './wallet-details-api.interface';

@Injectable({ providedIn: 'root' })
export class WalletDetailsApiService implements WalletDetailsApi {
  readonly #http = inject(HttpClient);
  readonly #organizationService = inject(OrganizationService);
  readonly #apiHost = environment.apiHost;

  getWalletDetails({ id: wallet_id, organizationId }: WalletCard): Observable<WalletCard> {
    const api = `${this.#apiHost}/wallets/${wallet_id}/`;

    return this.#http
      .get<WalletCard>(
        api,
        { headers: this.#organizationService.getHttpHeaders(organizationId) },
        // TODO need to ask API why orgId field is null and after their fix remove this map
      )
      .pipe(map(wallet => ({ ...wallet, orgId: wallet.organizationId })));
  }

  editWallet({ id: wallet_id, organizationId, name }: WalletCard): Observable<void> {
    const api = `${this.#apiHost}/wallets/${wallet_id}/`;

    return this.#http.post<void>(
      api,
      { name },
      {
        headers: this.#organizationService.getHttpHeaders(organizationId),
      },
    );
  }

  deleteWallet({ id: wallet_id, organizationId }: WalletCard): Observable<void> {
    const api = `${this.#apiHost}/wallets/${wallet_id}/activation/`;

    return this.#http.patch<void>(api, { active: false }, { headers: this.#organizationService.getHttpHeaders(organizationId) });
  }
}
